import { NAGOYA_16_WARDS } from '@/constants/company';

export default function AreaSection() {
  return (
    <section className="py-20 md:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-emerald-500" />
              <span className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase">Service Area</span>
            </div>
            <h2 className="text-[#1A2B4A] text-2xl md:text-4xl font-bold mb-4 leading-tight">
              名古屋16区<br />すべてに対応
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-10">
              名古屋市全16区を中心に、全国からのご相談も承ります。<br />
              地元密着のネットワークで、エリアに合わせた最適なご提案をします。
            </p>

            {/* Ward Grid */}
            <div className="grid grid-cols-4 gap-2 mb-8">
              {NAGOYA_16_WARDS.map((ward) => (
                <div
                  key={ward}
                  className="bg-[#F8F9FB] hover:bg-[#1A2B4A] hover:text-white rounded-lg py-2.5 px-2 text-center text-[#1A2B4A] text-xs font-medium transition-colors duration-200 cursor-default"
                >
                  {ward}
                </div>
              ))}
            </div>

            <div className="inline-flex items-center gap-3 bg-emerald-50 border border-emerald-100 rounded-full px-6 py-3">
              <i className="ri-global-line text-emerald-600 text-lg" />
              <span className="text-emerald-700 font-semibold text-sm">全国からのご相談もお受けします</span>
            </div>
          </div>

          {/* Right: Map Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden aspect-square max-w-md mx-auto lg:max-w-none">
              <img
                src="https://public.readdy.ai/ai/img_res/4c48f4dab4e5a09df90a52218db7b1f7.jpg"
                alt="名古屋市エリアマップ"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-[#1A2B4A]/20 to-transparent" />
            </div>
            {/* Floating badge */}
            <div className="absolute top-4 left-4 bg-white rounded-xl px-5 py-3">
              <div className="text-[#1A2B4A] font-bold text-lg">16区</div>
              <div className="text-gray-500 text-xs">全域対応</div>
            </div>
            <div className="absolute bottom-4 right-4 bg-[#1A2B4A] rounded-xl px-5 py-3">
              <div className="text-white font-bold text-lg">全国</div>
              <div className="text-white/60 text-xs">相談OK</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}